import qs from 'qs'

import HttpClient from 'services/HttpClient'
import { IQuery } from 'types/slices'

export class RolesRepository {
  api: typeof HttpClient

  constructor (api: typeof HttpClient) {
    this.api = api
  }

  getAllRoles ({ query }: { query: IQuery }) {
    const initialQuery = {
      order: {
        by: 'name',
        dir: 'asc'
      }
    }
    const params = { ...initialQuery, ...query }

    return this.api.get(
      `/roles/all?${decodeURIComponent(qs.stringify(params))}`
    )
  }

  getRoleById (id: string) {
    return this.api.get(`/roles/${id}`)
  }

  getAllPermissions () {
    return this.api.get('/role-permissions/permissions')
  }

  getPermissionById (id: string) {
    return this.api.get(`/role-permissions/${id}`)
  }

  gerPermissionsByRoleId (id: string) {
    const initialQuery = {
      order: {
        by: 'permission',
        dir: 'asc'
      },
      filter: {
        role: {
          id
        }
      }
    }

    return this.api.get(
      `role-permissions/all?${decodeURIComponent(qs.stringify(initialQuery))}`
    )
  }
}

 
export default new RolesRepository(HttpClient)
